const emptyResult = { formatted_address: '', address_components: [], types: [] }

export default class ReverseGeoGodingResult {
  constructor(results) {
    const result = this.selectResult(results)
    this.formattedAddress = result.formatted_address
    this.addressComponents = result.address_components.map(component => ({
      shortName: component.short_name,
      longName: component.long_name,
      types: component.types,
    }))
    this.types = result.types
  }

  /**
   * 地点名を取得する対象の result を選択して返す。
   * 最初の result が "Unnamed Road" を返す場合、2番目の result を利用する。
   * results が1つの要素しか持たない場合、空の result を返す。
   *
   * @param {Array} results
   */
  selectResult(results) {
    const [first, second] = results
    if (first.formatted_address.startsWith('Unnamed Road')) {
      return second || { ...emptyResult }
    } else {
      return results[0]
    }
  }

  /**
   * 規則に従い地点名を生成する
   */
  get pointName() {
    const type = (this.types && this.types[0]) || 'street_address'
    const addresses = [].concat(this.addressComponents)
    switch (type) {
      case 'premise':
        return addresses[0].shortName
      case 'colloquial_area':
        return addresses[0].shortName
      case 'locality':
        return addresses[0].shortName
      case 'administrative_area_level_1':
        return addresses[0].shortName
      case 'establishment':
        return addresses[0].shortName
      default:
        if (addresses.length > 3) {
          addresses.pop()
          addresses.pop()
          addresses.reverse()
          return addresses
            .map(address => {
              if (address.types.indexOf('sublocality_level_4') >= 0) {
                return address.shortName + ' -'
              } else {
                return address.shortName
              }
            })
            .join(' ')
        } else {
          return this.formattedAddress
        }
    }
  }
}
